<template>
  <div class="securityCode">
    <form-input
      label="セキュリティコード"
      name="security_code"
      type="tel"
      v-model="securityCode"
      input-width="90px"
      placeholder="例）123"
      :validation="{ rules: {
        required: true,
        numeric: true,
        max: 4
      } }"
    ></form-input>
    <div class="securityCode__question" @click="toggleAboutSecurityCode">
      <img width="20" height="20" src="/static/img/icons/question.svg">
    </div>
    <div class="securityCode__about media" :data-visible="visibleAboutSecurityCode">
      <div class="media__image">
        <img src="/static/img/security-code.png" width="48" height="30">
      </div>
      <div class="media__content">
        <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormSecurityCode",
  inject: ['$validator'],
  data(){
    return {
      visibleAboutSecurityCode: false,
      securityCode:''
    }
  },
  watch:{
    securityCode(n){
      this.$emit('input', n)
    }
  },
   methods: {
    toggleAboutSecurityCode() {
      this.visibleAboutSecurityCode = !this.visibleAboutSecurityCode
      if (this.visibleAboutSecurityCode) setTimeout(this.toggleAboutSecurityCode, 5000)
    }
   }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

 .securityCode {
    position: relative;
    &__question {
      position: absolute;
      left: 102px;
      top: 50%;
      cursor: pointer;
    }
    &__about {
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      color: $col_white;
      padding: 8px;
      z-index: 2;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
      border-radius: 4px;
      left: 120px;
      top: 0;
      align-items: center;
      pointer-events: none;
      opacity: 0;
      transition: opacity 250ms ease-in-out;
      &[data-visible='true'] {
        opacity: 1;
        pointer-events: auto;
      }
      .media__content p {
        font-size: 10px;
        line-height: 14px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/forms/FormSecurityCode.vue